import React from 'react';
import API from '../../../api';

export default class Budget extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      list: []
    }
    this.updateProfile = this.updateProfile.bind();
    this.handleClick = this.handleClick.bind();
  }

  componentWillReceiveProps(next){
    console.log('next ', next);
  }

  updateProfile = (value, isActive) => {
    let list = this.props.content;
    list.map((item, index) => {
      if (value == item.min_range){
        item.selected = isActive;
        item.profiles.map((profile) => {
          if(isActive === false){
            profile.selected = false;
          }
        })
      }
    })
    this.props.profiles(list); 
  }


  handleClick = (e) => {
    // this.reset()
    let selected = e.target;
    let name = selected.dataset['minvalue'];

    if(!selected.classList.contains('active')){
      selected.classList.add('active');
      this.updateProfile(name, true)
    }else{
      selected.classList.remove('active');
      this.updateProfile(name, false);
    }
  }

  render() {
    return (
      <section>
        <h3>Select your Hourly Rate Budget</h3>
        { this.props.content.map( (data, index) => {
          let isActive = data.selected ? 'active' : null
          return <button onClick={this.handleClick} ref="budget" data-minvalue={data.min_range} key={index} className={isActive}> ${data.min_range} - ${data.max_range}</button>
        })}
      </section>            
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/build-your-team/views/selectBudget.js